import { ReactComponent as Close } from "../../../icons/close.svg";
import { ChipProps } from "./types/chipProps";
import "./chip.scss";

const Chip = (props: ChipProps) => {
    const keyboardNavClose = (event: any) => { 
        // Enter
        return event.keyCode === 13 && props.onClose(props.data); 
    }
    
    let className = `chip ${props.mainClass ? "main-tag" : "brown-tag"}`;
    if (props.onlySingleTag) {
        className += " single-tag";
    };

    return (<div className={className}>
        {props.onClose !== undefined && <Close tabIndex={props.enableKeyboardNav ? 0 : -1} onKeyDown={keyboardNavClose} style={{cursor: 'pointer'}} onClick={() => { props.onClose(props.data) }} />}
        <div className="chip-text">{props.title}</div>
    </div>)
}

export default Chip;